import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme/gita-theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function routerBasename() {
  const p = process.env.PUBLIC_URL || '';
  if (!p || p === '.') return '';
  return p.endsWith('/') ? p.slice(0, -1) : p;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
